import { render, staticRenderFns } from "./PcbGroup.vue?vue&type=template&id=40d9a3f3&scoped=true"
import script from "./PcbGroup.vue?vue&type=script&lang=js"
export * from "./PcbGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d9a3f3",
  null
  
)

export default component.exports